'use client';

import { __spreadArray } from '../_virtual/_tslib.js';
import { useState, useEffect, useRef } from 'react';

function usePrevious(value) {
    var ref = useRef();
    useEffect(function () {
        ref.current = value;
    });
    return ref.current;
}
/**
 *
 * @see: https://usehooks.com/useDebounce/
 * @param value
 * @param delay
 */
function useDebounce(value, delay) {
    // State and setters for debounced value
    var _a = useState(value), debouncedValue = _a[0], setDebouncedValue = _a[1];
    var dependancies = [value, delay];
    if (typeof value !== 'string') {
        dependancies = __spreadArray(__spreadArray([], value, true), [delay], false);
    }
    useEffect(function () {
        // Update debounced value after delay
        var handler = setTimeout(function () {
            setDebouncedValue(value);
        }, delay);
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed ...
        // .. within the delay period. Timeout gets cleared and restarted.
        return function () {
            clearTimeout(handler);
        };
    }, dependancies // Only re-call effect if value or delay changes
    );
    return debouncedValue;
}
var useDidUpdateEffect = function (func, deps) {
    var didMount = useRef(false);
    useEffect(function () {
        if (didMount.current)
            func();
        else
            didMount.current = true;
    }, deps);
};
var useMountTransition = function (isMounted, unmountDelay) {
    var _a = useState(false), hasTransitionedIn = _a[0], setHasTransitionedIn = _a[1];
    useEffect(function () {
        var timeoutId;
        if (isMounted && !hasTransitionedIn) {
            setHasTransitionedIn(true);
        }
        else if (!isMounted && hasTransitionedIn) {
            timeoutId = setTimeout(function () { return setHasTransitionedIn(false); }, unmountDelay);
        }
        return function () {
            clearTimeout(timeoutId);
        };
    }, [unmountDelay, isMounted, hasTransitionedIn]);
    return hasTransitionedIn;
};

export { useDebounce as default, useDidUpdateEffect, useMountTransition, usePrevious };
//# sourceMappingURL=hooks.js.map
